type FormatCurrencyOptions = {
	value: number;
	code?: string;
	locale?: string;
	precision?: number;
};

type FormatStrAsMoneyOptions = {
	value: string;
	code?: string;
	locale?: string;
	precision?: number;
};

function formatCurrency(options: FormatCurrencyOptions) {
	const {
		value,
		code = 'RUR',
		locale = 'ru',
		precision = 2,
	} = options;
	const getCurrencyCode = (symbolicCode: string) => {
		const currencyUnitsByCode = {
			USD: 'USD',
			EUR: 'EUR',
			RUR: 'RUB',
			JPY: 'JPY',
			GBP: 'GBP'
		};

		return currencyUnitsByCode[symbolicCode]
			? currencyUnitsByCode[symbolicCode]
			: currencyUnitsByCode['RUR'];
	};

	return new Intl.NumberFormat(
		locale,
		{
			style: 'currency',
			currency: getCurrencyCode(code),
			minimumFractionDigits: precision,
			maximumFractionDigits: precision,
		}
	).format(value);
};

function formatStrAsMoney(options: FormatStrAsMoneyOptions): string {
	const { value } = options;
	const numberValue = Number(value);

	return numberValue
		? formatCurrency({ ...options, value: numberValue })
		: value === '0'
			? '0'
			: '';
}

export {
	formatCurrency,
	formatStrAsMoney,
};
